import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * @function Redirect
 * @summary on did mount will redirect to given location
 * @param {string} to
 */
function Redirect({ to }) {
  const navigate = useNavigate();
  
  useEffect(() => {
    navigate(to);
  }, [to, navigate]);
  
  return null;
}

export default Redirect;
